import { z } from 'zod';
import { moneySchema } from '../money';

/** Zeitbuchung / BDE (Modul hr): Stunden auf Projekt und/oder Fertigungsauftrag. */
export const createTimeEntrySchema = z.object({
  employeeId: z.string().uuid(),
  date: z.string().datetime(),
  hours: z.number().positive().max(24),
  projectId: z.string().uuid().optional(),
  productionOrderId: z.string().uuid().optional(),
  note: z.string().trim().max(500).optional(),
});
export type CreateTimeEntryInput = z.infer<typeof createTimeEntrySchema>;

export const updateTimeEntrySchema = z.object({
  date: z.string().datetime().optional(),
  hours: z.number().positive().max(24).optional(),
  projectId: z.string().uuid().nullable().optional(),
  productionOrderId: z.string().uuid().nullable().optional(),
  note: z.string().trim().max(500).nullable().optional(),
});
export type UpdateTimeEntryInput = z.infer<typeof updateTimeEntrySchema>;

export const timeEntryResponseSchema = z.object({
  id: z.string().uuid(),
  employeeId: z.string().uuid(),
  employeeName: z.string(),
  date: z.string().datetime(),
  hours: z.number(),
  projectId: z.string().uuid().nullable(),
  projectCode: z.string().nullable(),
  productionOrderId: z.string().uuid().nullable(),
  productionOrderNumber: z.string().nullable(),
  /** Ist-Kosten dieser Buchung (Stunden × Satz, Snapshot). null = kein Satz hinterlegt. */
  cost: moneySchema.nullable(),
  /**
   * false = Pause aus der Zeiterfassung (2026-09-29): gehört nicht in Stunden- oder
   * Kostensummen, auch nicht auf dem Projekt. BDE-Buchungen zählen immer.
   */
  countsAsWorkTime: z.boolean(),
  note: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type TimeEntryResponse = z.infer<typeof timeEntryResponseSchema>;
